/** TextField — single-line text input bound to one form key. */
import { Input } from "@/components/ui/input";
import { Field } from "../_shared";

export default function TextField({ field, value, set }) {
  const onChange = (e) => {
    let v = e.target.value;
    if (field.upperCase) v = v.toUpperCase();
    set(field.key, v);
  };
  return (
    <Field label={field.label} required={field.required || field.alwaysRequired}>
      <Input
        type={field.inputType || "text"}
        data-testid={field.testid}
        value={value ?? ""}
        onChange={onChange}
        placeholder={field.placeholder}
      />
    </Field>
  );
}
